import React from 'react';
import MainHero from './components/mainhero/mainhero';
import KtempleNav from './components/ktempleNav/ktempleNav';
import HomeBanner from './components/homeBanner/homeBanner';
import Footer from './components/Footer/Footer';
import VisitingTemple from './components/VisitingTemple/VisitingTemple';
import KnowMoreTemple from './components/knowMoreTemple/knowMoreTemple';
import CustomBanner from './components/Banner/customBanner';
import MainPage from './components/mainPage/mainPage';
import UpcomingEvents from './components/upcomingevents/upcomingevents';

function App() {

  return (
    <>
      <KtempleNav />
      {/* <CustomBanner sideText={["url", "url2", "url3"]}/> */}
      <UpcomingEvents />
      <MainHero />
      <MainPage />
      <HomeBanner />
      <KnowMoreTemple />
      <VisitingTemple />
      <Footer />
    </>
  )
}

export default App
